t = require('app/scripts/views/internal/teacup-with-helpers')('popover_confirmation_public_boards')

module.exports = t.renderable ({ templateModeEnabled }) ->
  t.div '.public-board-confirmation-popover', ->
    t.div '.public-board-confirmation-popover-title', ->

      if templateModeEnabled
        t.span ->
          t.format 'public-template-confirmation-description'

        t.button '.js-submit.wide.primary.full.make-public-confirmation-button', ->
          t.format 'public-template-confirm'

      else
        t.span ->
          t.format 'public-board-confirmation-description'

        t.button '.js-submit.wide.primary.full.make-public-confirmation-button', ->
          t.format 'confirm'

    t.hr()

    t.div '.public-board-confirmation-popover-invitation-link', ->
      t.p ->
        t.format 'looking-for-invite-link'
        t.a '.js-action-link.looking-for-invite-link', { href: '#', target: '_blank' }, ->
          if templateModeEnabled
            t.format 'invite-to-template-link'
          else
            t.format 'invite-to-board-link'
        t.format 'option'
